import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useGlobal } from "../../context/GlobalContext";
import { useAuraVoice } from "../../hooks/useAuraVoice";
import "./ExpectedResult.css";

import Card from "../../components/Card/Card";
import Stars from "../../assets/stars.svg";

const ExpectedResult = () => {
  const { state, dispatch } = useGlobal();
  const cardOptions = state.goals_options;
  useAuraVoice("E agora me conta... quais são os resultados que você quer alcançar?", "question");

  const [selectedOptions, setSelectedOptions] = useState([]);
  const navigate = useNavigate();

  const handleCardClick = (option) => {
    const isSelected = selectedOptions.includes(option);
    if (isSelected) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else if (selectedOptions.length < 3) {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const handleContinueClick = () => {
    dispatch({
      type: "UPDATE_STATE",
      payload: { selected_goals: selectedOptions },
    });
    navigate("/imagine-solution");
  };

  return (
    <motion.div
              className="er-container"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
      <img
        src={Stars}
        alt="Estrelas no fundo"
        className="er-stars-background"
      />

      <header className="er-header">
        <h1>Quais resultados você espera alcançar?</h1>
        <p>Escolha 3 resultados que mais se relacionam com o seu desafio</p>
      </header>

      <main className="er-grid">
        {cardOptions.map((optionText) => (
          <Card
            key={optionText}
            text={optionText}
            isSelected={selectedOptions.includes(optionText)}
            onClick={() => handleCardClick(optionText)}
          />
        ))}
      </main>

      <div className="continue-button-container">
        {selectedOptions.length === 3 && (
          <button className="new-continue-button" onClick={handleContinueClick}>
            Confirmar
          </button>
        )}
      </div>
    </motion.div>
  );
};

export default ExpectedResult;
